import type {BreakpointID, BreakpointsMap} from '@packages/systems/style/types';
import {
  BREAKPOINT_ID_XXL,
  BREAKPOINT_ID_XL,
  BREAKPOINT_ID_LARGE,
  BREAKPOINT_ID_MAIN,
  BREAKPOINT_ID_MEDIUM,
  BREAKPOINT_ID_SMALL,
  BREAKPOINT_ID_TINY,
} from '@packages/systems/style/breakpoint-ids';

type RawMediaQuery = {
  key: BreakpointID;
  min: number;
  max: number;
};

/**
 * The hardcoded list represents supported media queries by default
 * This should now be used anywhere outside of the IX2 functionality
 * Use breakpoints from StyleBlockStore instead
 * @type {Array}
 */
export const DEFAULT_MEDIA_QUERIES: Array<RawMediaQuery> = [
  {
    key: BREAKPOINT_ID_MAIN,
    min: 992,
    max: 10000,
  },
  {
    key: BREAKPOINT_ID_MEDIUM,
    min: 768,
    max: 991,
  },
  {
    key: BREAKPOINT_ID_SMALL,
    min: 480,
    max: 767,
  },
  {
    key: BREAKPOINT_ID_TINY,
    min: 0,
    max: 479,
  },
];

export const DEFAULT_VALUES: BreakpointsMap<number> = {
  [BREAKPOINT_ID_TINY]: 320,
  [BREAKPOINT_ID_SMALL]: 568,
  [BREAKPOINT_ID_MEDIUM]: 768,
  [BREAKPOINT_ID_MAIN]: 992,
  [BREAKPOINT_ID_LARGE]: 1280,
  [BREAKPOINT_ID_XL]: 1440,
  [BREAKPOINT_ID_XXL]: 1920,
};
